export const PHONE_BREAKPOINT = 500; // max width for phone category
export const TABLET_BREAKPOINT = 835; // min width for desktop, max for tablet category

export type ResponsiveConfig = {
  phoneBreakpoint: number; // <= phoneBreakpoint => phone
  tabletBreakpoint: number; // < tabletBreakpoint => tablet, >= => desktop
};

export const responsiveConfig: ResponsiveConfig = {
  phoneBreakpoint: PHONE_BREAKPOINT,
  tabletBreakpoint: TABLET_BREAKPOINT,
};
